// extracted by mini-css-extract-plugin
export default {"productcard":"wV","productimage":"xV","username":"yV","multiBagName":"zV","productinfo":"AV","productinfoinner":"BV","productname":"CV","productsubheader":"EV","productdescription":"FV","productnumbers":"GV","productnumberstitle":"HV","productnumbersitem":"IV","number":"JV","numbertext":"KV","tabs":"LV","benefitsblock":"MV","benefit":"NV","benefitname":"OV","benefitdescription":"PV","ingredientsblock":"QV","tipsblock":"RV","mobileonly":"SV"};
    if(module.hot) {
      // 1738836197919
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  